import React from 'react';
import styles from './OfferCard.module.css';

const OfferCard = ({ id, offer, onChange }) => {
    const { title, description, active, icon } = offer;

    const isFirst = id === 1; // la première offre

    return (
        <div className={styles.offer} aria-live="polite">
            <img className={styles.icon} src={icon} alt="" />

            {/* Champ titre */}
            <input
                type="text"
                placeholder="Titre de l'offre"
                className={styles.field}
                value={title}
                readOnly={isFirst}
                onChange={
                    isFirst
                        ? undefined
                        : (e) => onChange({ title: e.target.value })
                }
                aria-label="Titre de l'offre"
            />

            {/* Champ description */}
            <textarea
                className={styles.description}
                rows={8}
                cols={30}
                placeholder="Décris ton offre ici..."
                value={description}
                readOnly={isFirst}
                onChange={
                    isFirst
                        ? undefined
                        : (e) => onChange({ description: e.target.value })
                }
                aria-label="Description de l'offre"
            />

            {/* Pas de bouton si c’est la première offre */}
            {!isFirst && (
                <button
                    type="button"
                    onClick={() => onChange({ active: !active })}
                    className={styles.btn}
                    aria-pressed={active}
                >
                    {active ? "Désactiver l'offre" : "Activer l'offre"}
                </button>
            )}

            <p
                className={styles.state}
                style={{ color: active ? 'green' : 'red' }}
            >
                {active ? "L'offre est activée" : "L'offre est désactivée"}
            </p>
        </div>
    );
};

export default OfferCard;
